import React, { useCallback } from 'react'
import { Image } from '@/atoms/Image'
import { InternalLink } from '@/atoms/InternalLink'
import { ProjectDescription } from '@/services/ProjectsService'
import { getLogoTransformation } from '@/utils/Cloudinary'
import { useSafeTrack } from '@/utils/analytics'

interface ProjectTileProps extends ProjectDescription {
  height?: number
  href?: string
  width?: number
}

export const ProjectTile: React.FC<ProjectTileProps> = ({
  discoveryPosterCloudinaryPath,
  discoveryPosterTransformation,
  height = 490,
  href,
  logoCloudinaryPath,
  name,
  slug,
  width = 294,
}) => {
  const track = useSafeTrack()
  const logoTransformation = getLogoTransformation({ logoCloudinaryPath })
  const src = `c_crop,ar_0.6/${logoTransformation}${discoveryPosterTransformation}/${discoveryPosterCloudinaryPath}.webp`

  const handleClick = useCallback(() => {
    track('Project Tile Clicked', { slug })
  }, [track, slug])

  return (
    <InternalLink
      key={slug}
      href={href || `/watch/${slug}`}
      aria-label={`project-tile-${slug}`}
      className="block h-fit duration-[400ms] ease-in-out hover:z-10 md:hover:scale-[1.08]"
      onClick={handleClick}
    >
      <Image
        aria-label={name}
        alt={name}
        src={src}
        height={height || 490}
        width={width || 294}
        className="rounded-lg bg-black"
      />
    </InternalLink>
  )
}
